import { render, staticRenderFns } from "./AdmIcon.vue?vue&type=template&id=1e916f89&"
import script from "./AdmIcon.vue?vue&type=script&lang=ts&"
export * from "./AdmIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports